module.exports = __webpack_public_path__ + "static/media/p2.936b8a3e.jpeg";